import {Box, Link, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {AllowedCountryCodesSignIn} from '@/app/auth/constants/AllowedPhoneNumbers';
import {
  AppButton,
  AppButtonVariant,
  PhoneInputTextField,
} from '@/app/shared-components';
import {InviterAvatar} from '@/app/shared-components/InviterAvatar/InviterAvatar';
import {LINKS} from '@/constants/LinksConstants';

import {FdicIcon} from './FdicIcon';

interface SplitsPhoneCardProps {
  phone: string;
  setPhone: (value: string) => void;
  isPhoneValid: boolean;
  onSubmitPhone: () => void;
  onGetAvatarImage?: () => React.ReactNode;
  inviterName?: string;
  isGroupJoinFlow?: boolean;
}

export function SplitsPhoneCard({
  phone,
  setPhone,
  isPhoneValid,
  onSubmitPhone,
  onGetAvatarImage,
  inviterName,
  isGroupJoinFlow = false,
}: SplitsPhoneCardProps) {
  const {t} = useTranslation();

  const title = isGroupJoinFlow
    ? t('groups.enter_phone.title')
    : t('split_bills_page.landing.phone_title');

  return (
    <Box className="splits-landing-card splits-landing-card-phone">
      <Box
        component="div"
        className="splits-landing-card-fdic">
        <FdicIcon />
      </Box>
      <Box className="splits-landing-card-phone-body">
        {onGetAvatarImage && onGetAvatarImage()}
        {inviterName && <InviterAvatar inviterName={inviterName} />}
        <Typography
          className="splits-landing-headline"
          component="h1">
          {title}
        </Typography>
        <PhoneInputTextField
          id="splits-landing-phone-input"
          value={phone}
          onChange={setPhone}
          countries={AllowedCountryCodesSignIn}
          showCountryCode={false}
        />
        <Box className="splits-landing-phone-continue-wrap">
          <AppButton
            id="splits-landing-phone-continue"
            data-testid="splits-landing-phone-continue"
            onClick={onSubmitPhone}
            label={t('split_bills_page.landing.continue')}
            variant={AppButtonVariant.onPrimary}
            disabled={!isPhoneValid}
          />
        </Box>
        <Typography className="splits-landing-phone-disclaimer">
          {t('split_bills_page.landing.phone_disclaimer_prefix')}
          <Link
            href={LINKS.PRIVACY_POLICY}
            className="splits-landing-disclaimer-link"
            target="_blank"
            rel="noopener noreferrer"
            underline="always"
            color="inherit">
            {t('split_bills_page.landing.privacy_policy')}
          </Link>
          {t('split_bills_page.landing.phone_disclaimer_suffix')}
        </Typography>
      </Box>
    </Box>
  );
}
